export default "__VITE_ASSET__Cq06qlSj__"